import { NavLink } from "react-router";
import { FaInstagram } from 'react-icons/fa';

interface InstagramHandlerProps {
    handle: string;
    url: string;
    textColor?: string;
}

export const InstagramHandler = ({ handle, url, textColor = 'text-white' }: InstagramHandlerProps) => {
    return (
        <NavLink 
            to={url}
            className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-opacity-20 bg-white hover:bg-opacity-30 transition-all duration-300 group w-fit ${textColor}`}
            target="_blank"
            rel="noopener noreferrer"
        >
            <FaInstagram className="text-xl transform group-hover:scale-110 transition-transform duration-300" />
            <span className="text-sm font-medium group-hover:underline truncate">{handle}</span>
        </NavLink>
    )
}
